<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      content-class="overflow-hidden"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>Events <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="hideEvents"
              class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
          <!--<v-col class="col-12 d-flex justify-center">
            <h2 class="mt-2" v-if="selectedDevice">{{ getDeviceTypes.filter(tp => tp.id == selectedDevice.device.deviceTypeId)[0].name }}+{{ getSubDeviceTypes.filter(tp => tp.id == selectedDevice.subDevice.typeId)[0].name }}, ID: DVC {{`000${selectedDevice.id}`.substring(`000${selectedDevice.id}`.length-3, `000${selectedDevice.id}`.length)}}</h2>
          </v-col>-->
        </v-card-title>
        <v-card-text>
          <v-row class="mt-1">
            <v-col class="col-4">
              <v-dialog
                ref="dialogOne"
                v-model="modalDateOne"
                :return-value.sync="dateOne"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    v-model="dateOne"
                    label="Start with"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateOne"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modalDateOne = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogOne.save(dateOne)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col class="col-4">
              <v-dialog
                ref="dialogTwo"
                v-model="modalDateTwo"
                :return-value.sync="dateTwo"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    v-model="dateTwo"
                    label="End with"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTwo"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modalDateTwo = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialogTwo.save(dateTwo)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col class="col-4">
              <v-select
                :disabled="(loading)"
                outlined
                v-model="selectedEventType"
                :items="eventTypes"
                item-text="message"
                item-value="id"
                :menu-props="{ maxHeight: '400', offsetY: true }"
                label="Event type"
                persistent-hint
                dense
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters>
                <v-col class="col-12 mt-5 d-flex justify-space-around justify-center">
                  <div class="fix-height scroll" v-if="eventsData.length > 0">
                    <v-data-table
                      disable-pagination
                      hide-default-footer
                      :headers="headersEvents"
                      :items="eventsData"
                      class="elevation-1">
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="col-12 d-flex justify-end mt-4">
              <v-btn :disabled="loading" depressed outlined 
                class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'"
                @click="loadEvents">
                Load Events
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog', 'device', 'getEvents'],
    name: 'Events',
    data(){
      return {
        loading: false,
        modalDateOne: false,
        modalDateTwo: false,
        dateOne: new Date().toISOString().substring(0, 10),
        dateTwo: new Date().toISOString().substring(0, 10),
        selectedDevice: null,
        eventTypes: [],
        selectedEventType: 1,
        headersEvents: [
          { 
            align: 'center',
            text: 'DATE/TIME',
            sortable: true,
            value: 'EventDateTime',
            width: '20%'
          },
          { 
            align: 'left',
            text: 'EVENT',
            sortable: true,
            value: 'EventText',
            width: '60%'
          },
          { 
            align: 'center',
            text: 'NAME',
            sortable: true,
            value: 'EventName',
            width: '20%'
          }
        ],
        eventsData: []
      }
    },
    components:{
    },
    computed:{
      ...mapGetters(['getSubjectCreationDatas', 'getDeviceTypes', 'getSubDeviceTypes', 'getSelectedDevice']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    async mounted(){
      this.$root.$on('showEvents', async (dv) => {
        this.selectedDevice = dv
        await this.loadEvents()
      })
      await this.getEventTypes()
      .then(res => {
        this.eventTypes = res.eventTypes.sort((a,b) => a.id-b.id)
      })
      .catch(e => {
        /*console.log(e)
        this.$root.$emit('globalError', e.code)*/
      })
    },
    methods:{
      ...mapActions(['getEventTypes', 'getEventsApi']),
      async loadEvents(){
        this.loading = true
        this.$root.$emit('loading', "start")
        await this.getEventsApi({
          DeviceId: this.selectedDevice.id,
          EventTypeId: this.selectedEventType,
          DateStart: `${this.dateOne}T00:01Z`,
          DateEnd: `${this.dateTwo}T23:59Z`
        })
        .then(res =>{
          this.eventsData = []
          this.loading = false
          res.eventHistories.forEach(event => {
            this.eventsData.push({
              EventDateTime: event.dateTime.split('.')[0].replace("T", " "),
              EventText: event.message,
              EventName: event.userName
            })
          })
          this.$root.$emit('loading', "end")
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
          this.loading = false
        })
      },
      hideEvents(){
        this.$emit('hideEvents')
      },
    }
  }
</script>
<style>
.overflow-hidden{
  overflow-x:hidden;
}
</style>